/**
 * Used to collect various logs during the running of js
 * @param runtimeError: Whether to collect runtime errors and resource loading errors. Default: true
 * @param rejectError: Collect reject errors. Default: true
 * @param consoleError: Whether to collect errors printed by console. error. Default: false
 * @param unhandledCodeArr: Does rejectError not capture the state? The default is [403, 401]
 * @param unhandledStringArr: RejectError does not capture a String. The default is ["cancel"]
 */
/**
 * 用于收集 js 运行过程中各种日志
 * @param runtimeError: 是否收集运行期错误和资源加载错误，默认：true
 * @param rejectError: 是否收集 reject 错误，默认：true
 * @param consoleError: 是否收集 console.error 打印的错误，默认：false
 * @param unhandledCodeArr: rejectError 不捕捉状态吗，默认[403, 401]
 * @param unhandledStringArr: rejectError 不捕捉 String，默认["cancel"]
 */

export const jsErrorCollection = (
  {
    runtimeError = true,
    rejectError = true,
    consoleError = false,
    unhandledCodeArr = [],
    unhandledStringArr = []
  },
  callback
) => {
  if (runtimeError) {
    // JS runtime error and resource loading error
    // JS 运行时错误和资源加载错误
    window.addEventListener(
      'error',
      ({ error, target }) => {
        if (target.outerHTML) {
          // img error collection
          const errLog = `${JSON.stringify(target.outerHTML)}`
          callback(errLog)
        } else {
          const errLog = `${error?.stack?.substr(0, 300)}`
          callback(errLog)
        }
      },
      // use Event capture  to collection  img error
      true
    )
  }
  if (rejectError) {
    // When the promise is rejected and the error message is not processed, an unhandledrejection will be thrown
    // promise 被 reject 并且错误信息没有被处理的时候，会抛出一个 unhandledrejection
    // Interface error handling, cross origin, 404, 401
    // 接口错误处理，cross origin , 404, 401
    window.addEventListener('unhandledrejection', ({ reason }) => {
      let errLog = ''
      if (typeof reason === 'string') {
        errLog = reason
      } else if (reason instanceof Object) {
        errLog = JSON.stringify(reason)
      } else {
        errLog = '未知类型'
      }
      // You can add non capture status code here
      // 此处可添加不捕捉状态码
      const unhandledCode = '403,401'
      // You can add a string without capturing here
      // 此处可添加不捕捉 string
      const unhandledString = 'cancel'

      for (const string of unhandledCode.split(',').concat(unhandledCodeArr)) {
        if (errLog.includes(string)) {
          return
        }
      }
      for (const string of unhandledString.split(',').concat(unhandledStringArr)) {
        if (errLog.includes(string)) {
          return
        }
      }
      // Delay return
      // 延时返回
      const time = setTimeout(() => {
        clearInterval(time)
        callback(errLog)
      }, 200)
    })
  }
  if (consoleError) {
    // In some special cases, you also need to capture to process console.error. The capture method is to rewrite window.console.error
    // 一些特殊情况下，还需要捕获处理 console.error，捕获方式就是重写 window.console.error
    const _oldConsoleError = window.console.error
    window.console.error = function () {
      // eslint-disable-next-line prefer-rest-params
      const errLog = Object.values(arguments).join(',')
      if (errLog.indexOf('custom') === -1) {
        callback(errLog)
      }
      // @ts-ignore
      // eslint-disable-next-line prefer-rest-params
      _oldConsoleError && _oldConsoleError.apply(window, arguments)
    }
  }
}

export default {}